import axios from "axios";
import { toast } from "react-toastify";
import { auth } from "../../firebase";

// Create an Axios instance
export const axiosAuth = axios.create();

// Add a request interceptor
axiosAuth.interceptors.request.use(
  async (config) => {
    const token = await localStorage.getItem("fb_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
// axiosAuth.interceptors.response.use(
//   response => response,
//   async error => {
//     if (error.response && error.response.status === 401) {
//       // Token might be expired, refresh token
//       console.log('inte res', error);

//       try {
//         const newToken = await refreshToken();
//         if (newToken) {
//           // Retry the original request with the new token
//           error.config.headers['Authorization'] = `Bearer ${newToken}`;
//           return axiosAuth.request(error.config);
//         }
//       } catch (refreshError) {
//         console.error('Failed to refresh token', refreshError);
//         // Optionally, handle user re-authentication here
//       }
//     }
//     return Promise.reject(error);
//   },
// );
axiosAuth.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log(error);
    if (error.response && error.response.status === 401) {
      console.log("calling");
      try {
        const newToken = await refreshToken();
        if (newToken) {
          // Retry the original request with the new token
          error.config.headers["Authorization"] = `Bearer ${newToken}`;
          return axiosAuth.request(error.config);
        }
      } catch (refreshError) {
        console.error("Failed to refresh token", refreshError);
        // Optionally, handle user re-authentication here
      }
      // Handle unauthorized errors
      console.error("Unauthorized request:", error.response.data.message);
      // Optionally, redirect to login or show an error message
    } else {
      // Handle other errors
      console.error(
        "An error occurred:",
        error.response ? error.response.data.message : error.message
      );
    }
    return Promise.reject(error);
  }
);

async function refreshToken() {
  try {
    const user = auth?.currentUser;
    // console.log('user', user);
    if (user) {
      const newToken = await user?.getIdToken(true);
      localStorage.setItem("fb_token", newToken);
      return newToken;
    }
    return null;
  } catch (error) {
    console.error("Failed to refresh token", error);
    return null;
  }
}

export default axiosAuth;
